module.exports = __webpack_public_path__ + "static/media/loss.40e49718.wav";